export default function AppEntrySection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="px-6 md:px-8 max-w-4xl mx-auto">
        <div className="bg-gradient-to-br from-primary-500 via-primary-400 to-accent-400 rounded-2xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-8">
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-2xl md:text-3xl font-heading text-white mb-3">
              随时随地 · 畅享综艺
            </h2>
            <p className="text-white/90 text-sm md:text-base leading-relaxed mb-6">
              无需下载App，手机浏览器直接访问红桃影院即可综艺在线观看。
              支持iOS、Android、iPad等所有移动设备，高清流畅不缓冲，
              让你通勤、午休、睡前随时随地免费看热门综艺和搞笑综艺。
            </p>
            <div className="flex flex-wrap items-center justify-center md:justify-start gap-3">
              <a
                href="#index"
                className="px-6 py-3 bg-white text-primary-600 font-semibold rounded-lg hover:bg-white/90 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-smartphone-line mr-2"></i>
                手机端立即观看
              </a>
              <a
                href="#features"
                className="px-6 py-3 bg-white/20 text-white font-semibold rounded-lg hover:bg-white/30 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line mr-2"></i>
                了解更多
              </a>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="w-40 h-40 md:w-48 md:h-48 rounded-2xl bg-white/15 flex items-center justify-center">
              <i className="ri-smartphone-line text-6xl md:text-7xl text-white"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}